var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerLayout } from '../../layout/AbfragerLayout';
let AbfragerLoadingScene = class AbfragerLoadingScene extends React.PureComponent {
    render() {
        const { app } = this.props;
        const answerContainer = (React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement("div", { style: { flex: '0 1 auto' } },
                React.createElement("div", { className: "sk-fading-circle" },
                    React.createElement("div", { className: "sk-circle1 sk-circle" }),
                    React.createElement("div", { className: "sk-circle2 sk-circle" }),
                    React.createElement("div", { className: "sk-circle3 sk-circle" }),
                    React.createElement("div", { className: "sk-circle4 sk-circle" }),
                    React.createElement("div", { className: "sk-circle5 sk-circle" }),
                    React.createElement("div", { className: "sk-circle6 sk-circle" }),
                    React.createElement("div", { className: "sk-circle7 sk-circle" }),
                    React.createElement("div", { className: "sk-circle8 sk-circle" }),
                    React.createElement("div", { className: "sk-circle9 sk-circle" }),
                    React.createElement("div", { className: "sk-circle10 sk-circle" }),
                    React.createElement("div", { className: "sk-circle11 sk-circle" }),
                    React.createElement("div", { className: "sk-circle12 sk-circle" })))));
        return (React.createElement(AbfragerLayout, { app: app, questionContainer: null, answerContainer: answerContainer, answerBottom: null, menuContainer: null }));
    }
};
AbfragerLoadingScene = __decorate([
    observer
], AbfragerLoadingScene);
export { AbfragerLoadingScene };
